import React from 'react'
import PropTypes from 'prop-types'
import injectStyles from 'react-jss'
import classNames from 'classnames'
import styles from '../styles'
import SearchIcon from '../../../../Assets/Images/icons/globalSearch'

const ChatSearchView = ({ onChange, value, classes }) => {
  return (
    <section className={classes.wrapper}>
      <SearchIcon />
      <input
        className={
          value.length > 0
            ? classNames(classes.input, classes.inputFilled)
            : classes.input
        }
        onChange={onChange}
        value={value}
        placeholder={'Search conversations...'}
        cypress_id={'chatSearch'}
      />
    </section>
  )
}

ChatSearchView.propTypes = {
  classes: PropTypes.object,
  onChange: PropTypes.func,
  value: PropTypes.string,
}

export default injectStyles(styles)(ChatSearchView)
